// Mock pins (polygon coordinates) for local development testing
// Each area can have pins that form a polygon on the map

export const MOCK_PINS = {
    // Bokskogen - polygon near Torup
    9001: [
        { id: 1, area_id: 9001, latitude: 55.5450, longitude: 13.1800, pin_order: 0 },
        { id: 2, area_id: 9001, latitude: 55.5500, longitude: 13.1950, pin_order: 1 },
        { id: 3, area_id: 9001, latitude: 55.5420, longitude: 13.2100, pin_order: 2 },
        { id: 4, area_id: 9001, latitude: 55.5350, longitude: 13.2000, pin_order: 3 },
        { id: 5, area_id: 9001, latitude: 55.5380, longitude: 13.1750, pin_order: 4 },
    ],
    // Söderåsen - polygon in the national park area
    9002: [
        { id: 6, area_id: 9002, latitude: 56.0200, longitude: 13.2500, pin_order: 0 },
        { id: 7, area_id: 9002, latitude: 56.0300, longitude: 13.2800, pin_order: 1 },
        { id: 8, area_id: 9002, latitude: 56.0150, longitude: 13.3000, pin_order: 2 },
        { id: 9, area_id: 9002, latitude: 56.0050, longitude: 13.2700, pin_order: 3 },
    ],
    // Stenshuvud - coastal polygon
    9003: [
        { id: 10, area_id: 9003, latitude: 55.6650, longitude: 14.2700, pin_order: 0 },
        { id: 11, area_id: 9003, latitude: 55.6700, longitude: 14.2900, pin_order: 1 },
        { id: 12, area_id: 9003, latitude: 55.6580, longitude: 14.2950, pin_order: 2 },
        { id: 13, area_id: 9003, latitude: 55.6550, longitude: 14.2750, pin_order: 3 },
    ],
    // Kullaberg - no pins yet (for testing adding new polygon)
    9004: [],
    // Dalby Söderskog - small polygon
    9005: [
        { id: 14, area_id: 9005, latitude: 55.6700, longitude: 13.3500, pin_order: 0 },
        { id: 15, area_id: 9005, latitude: 55.6750, longitude: 13.3600, pin_order: 1 },
        { id: 16, area_id: 9005, latitude: 55.6680, longitude: 13.3650, pin_order: 2 },
        { id: 17, area_id: 9005, latitude: 55.6650, longitude: 13.3550, pin_order: 3 },
    ],
    // Skrylle - no pins yet
    9006: [],
    // Häckeberga - polygon
    9007: [
        { id: 18, area_id: 9007, latitude: 55.5800, longitude: 13.4200, pin_order: 0 },
        { id: 19, area_id: 9007, latitude: 55.5850, longitude: 13.4400, pin_order: 1 },
        { id: 20, area_id: 9007, latitude: 55.5750, longitude: 13.4500, pin_order: 2 },
        { id: 21, area_id: 9007, latitude: 55.5700, longitude: 13.4300, pin_order: 3 },
    ],
};

// Helper function to get pins for an area
export const getMockPinsForArea = (areaId) => {
    return MOCK_PINS[areaId] || [];
};

// Helper function to get all areas with their pins
export const getMockAreasWithPins = (areas) => {
    return areas.map(area => ({
        ...area,
        pins: MOCK_PINS[area.id] || []
    }));
};

// Simulated "database" operations for local testing
let localPinsData = { ...MOCK_PINS };

export const saveMockPins = (areaId, pins) => {
    localPinsData[areaId] = pins.map((pin, index) => ({
        id: Date.now() + index,
        area_id: areaId,
        latitude: pin.lat,
        longitude: pin.lng,
        pin_order: pin.order || index,
    }));
    console.log(`[Mock DB] Saved ${pins.length} pins for area ${areaId}`);
    return localPinsData[areaId];
};

export const deleteMockPins = (areaId) => {
    localPinsData[areaId] = [];
    console.log(`[Mock DB] Deleted pins for area ${areaId}`);
    return true;
};

export const getLocalMockPins = (areaId) => {
    return localPinsData[areaId] || [];
};

export const getAllLocalMockAreasWithPins = (areas) => {
    return areas.map(area => ({
        ...area,
        pins: localPinsData[area.id] || []
    }));
};

export default MOCK_PINS;
